import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e6) { throw _e6; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e7) { didErr = true; err = _e7; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function e(e, t, r, n) {
  return new (r || (r = Promise))(function (o, a) {
    function i(e) {
      try {
        d(n.next(e));
      } catch (e) {
        a(e);
      }
    }
    function c(e) {
      try {
        d(n.throw(e));
      } catch (e) {
        a(e);
      }
    }
    function d(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(i, c);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
var t = ["geforce 320m", "geforce 8600", "geforce 8600m gt", "geforce 8800 gs", "geforce 8800 gt", "geforce 9400", "geforce 9400m g", "geforce 9400m", "geforce 9600m gt", "geforce 9600m", "geforce fx go5200", "geforce gt 120", "geforce gt 130", "geforce gt 330m", "geforce gtx 285", "google swiftshader", "intel g41", "intel g45", "intel gma 4500mhd", "intel gma x3100", "intel hd 3000", "intel q45", "legacy", "mali-2", "mali-3", "mali-4", "quadro fx 1500", "quadro fx 4", "quadro fx 5", "radeon hd 2400", "radeon hd 2600", "radeon hd 4670", "radeon hd 4850", "radeon hd 4870", "radeon hd 5670", "radeon hd 5750", "radeon hd 6290", "radeon hd 6300", "radeon hd 6310", "radeon hd 6320", "radeon hd 6490m", "radeon hd 6630m", "radeon hd 6750m", "radeon hd 6770m", "radeon hd 6970m", "sgx 543", "sgx543"];
function r(e) {
  return e = e.toLowerCase().replace(/^angle ?\((.+)\)*$/, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
var n = "undefined" == typeof window,
  o = function () {
    if (n) return;
    var _window$navigator = window.navigator,
      e = _window$navigator.userAgent,
      t = _window$navigator.platform,
      r = _window$navigator.maxTouchPoints,
      o = /(iphone|ipod|ipad)/i.test(e),
      a = "iPad" === t || "MacIntel" === t && r > 0 && !window.MSStream;
    return {
      isIpad: a,
      isMobile: /android/i.test(e) || o || a,
      isSafari12: /Version\/12.+Safari/.test(e)
    };
  }();
function a(e, t, r) {
  if (!r) return [t];
  var n = function (e) {
      var t = "\n    precision highp float;\n    attribute vec3 aPosition;\n    varying float vvv;\n    void main() {\n      vvv = 0.31622776601683794;\n      gl_Position = vec4(aPosition, 1.0);\n    }\n  ",
        r = "\n    precision highp float;\n    varying float vvv;\n    void main() {\n      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\n      enc = fract(enc);\n      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\n      gl_FragColor = enc;\n    }\n  ",
        n = e.createShader(35633),
        o = e.createShader(35632),
        a = e.createProgram();
      if (!(o && n && a)) return;
      e.shaderSource(n, t), e.shaderSource(o, r), e.compileShader(n), e.compileShader(o), e.attachShader(a, n), e.attachShader(a, o), e.linkProgram(a), e.detachShader(a, n), e.detachShader(a, o), e.deleteShader(n), e.deleteShader(o), e.useProgram(a);
      var i = e.createBuffer();
      e.bindBuffer(34962, i), e.bufferData(34962, new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]), 35044);
      var c = e.getAttribLocation(a, "aPosition");
      e.vertexAttribPointer(c, 3, 5126, !1, 0, 0), e.enableVertexAttribArray(c), e.clearColor(1, 1, 1, 1), e.clear(16384), e.viewport(0, 0, 1, 1), e.drawArrays(4, 0, 3);
      var d = new Uint8Array(4);
      return e.readPixels(0, 0, 1, 1, 6408, 5121, d), e.deleteProgram(a), e.deleteBuffer(i), d.join("");
    }(e),
    a = "801621810",
    i = "8016218135",
    c = "80162181161",
    d = (null == o ? void 0 : o.isIpad) ? [["a7", c, 12], ["a8", i, 15], ["a8x", i, 15], ["a9", i, 15], ["a9x", i, 15], ["a10", i, 15], ["a10x", i, 15], ["a12", a, 15], ["a12x", a, 15], ["a12z", a, 15], ["a14", a, 15], ["m1", a, 15]] : [["a7", c, 12], ["a8", i, 12], ["a9", i, 15], ["a10", i, 15], ["a11", a, 15], ["a12", a, 15], ["a13", a, 15], ["a14", a, 15]];
  var l;
  "80162181255" === n ? l = d.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
      e = _ref2[2];
    return e >= 14;
  }) : (l = d.filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      e = _ref4[1];
    return e === n;
  }), l.length || (l = d));
  return l.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      e = _ref6[0];
    return "apple ".concat(e, " gpu");
  });
}
var i = [],
  c = [];
function d(e, t) {
  if (e === t) return 0;
  var r = e;
  e.length > t.length && (e = t, t = r);
  var n = e.length,
    o = t.length;
  for (; n > 0 && e.charCodeAt(~-n) === t.charCodeAt(~-o);) n--, o--;
  var a,
    d = 0;
  for (; d < n && e.charCodeAt(d) === t.charCodeAt(d);) d++;
  if (n -= d, o -= d, 0 === n) return o;
  var l,
    s,
    f = 0,
    u = 0,
    h = 0;
  for (; u < n;) c[u] = e.charCodeAt(d + u), i[u] = ++u;
  for (; h < o;) for (a = t.charCodeAt(d + h), l = h++, f = h, u = 0; u < n; u++) s = a === c[u] ? l : l + 1, l = i[u], f = i[u] = l > f ? s > f ? f + 1 : s : s > l ? l + 1 : s;
  return f;
}
function l(e) {
  return null != e;
}
var s = /*#__PURE__*/function (_Error) {
  _inherits(s, _Error);
  var _super = _createSuper(s);
  function s(e) {
    var _this;
    _classCallCheck(this, s);
    _this = _super.call(this, e), Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof s ? this.constructor : void 0).prototype);
    return _this;
  }
  return _createClass(s);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var f = function f() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$mobileTiers = _ref7.mobileTiers,
    i = _ref7$mobileTiers === void 0 ? [0, 15, 30, 60] : _ref7$mobileTiers,
    _ref7$desktopTiers = _ref7.desktopTiers,
    c = _ref7$desktopTiers === void 0 ? [0, 15, 30, 60] : _ref7$desktopTiers,
    _ref7$override = _ref7.override,
    f = _ref7$override === void 0 ? {} : _ref7$override,
    u = _ref7.glContext,
    _ref7$failIfMajorPerf = _ref7.failIfMajorPerformanceCaveat,
    h = _ref7$failIfMajorPerf === void 0 ? !1 : _ref7$failIfMajorPerf,
    _ref7$benchmarksURL = _ref7.benchmarksURL,
    g = _ref7$benchmarksURL === void 0 ? "https://unpkg.com/detect-gpu@4.0.50/dist/benchmarks" : _ref7$benchmarksURL;
  return e(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var p, _f$isIpad, m, _f$isMobile, v, _f$screenSize, w, _f$loadBenchmarks, x, A, P, b, S, _e, _t, y, _e4, _y$, C, E, L, M, $, _e5;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          p = {};
          if (!n) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", {
            tier: 0,
            type: "SSR"
          });
        case 3:
          _f$isIpad = f.isIpad, m = _f$isIpad === void 0 ? !!(null == o ? void 0 : o.isIpad) : _f$isIpad, _f$isMobile = f.isMobile, v = _f$isMobile === void 0 ? !!(null == o ? void 0 : o.isMobile) : _f$isMobile, _f$screenSize = f.screenSize, w = _f$screenSize === void 0 ? window.screen : _f$screenSize, _f$loadBenchmarks = f.loadBenchmarks, x = _f$loadBenchmarks === void 0 ? function (t) {
            return e(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var e;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return fetch("".concat(g, "/").concat(t)).then(function (e) {
                      return e.json();
                    });
                  case 2:
                    e = _context.sent;
                    if (!(parseInt(e.shift().split(".")[0], 10) < 4)) {
                      _context.next = 5;
                      break;
                    }
                    throw new s("Detect GPU benchmark data is out of date. Please update to version 4x");
                  case 5:
                    return _context.abrupt("return", e);
                  case 6:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          } : _f$loadBenchmarks;
          A = f.renderer;
          P = function P(e, t, r, n, o) {
            return {
              device: o,
              fps: n,
              gpu: r,
              isMobile: v,
              tier: e,
              type: t
            };
          };
          S = "";
          if (!A) {
            _context3.next = 11;
            break;
          }
          A = r(A), b = [A];
          _context3.next = 18;
          break;
        case 11:
          _e = u || function (e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var r = {
              alpha: !1,
              antialias: !1,
              depth: !1,
              failIfMajorPerformanceCaveat: t,
              powerPreference: "high-performance",
              stencil: !1
            };
            e && delete r.powerPreference;
            var n = window.document.createElement("canvas"),
              o = n.getContext("webgl", r) || n.getContext("experimental-webgl", r);
            return null != o ? o : void 0;
          }(null == o ? void 0 : o.isSafari12, h);
          if (_e) {
            _context3.next = 14;
            break;
          }
          return _context3.abrupt("return", P(0, "WEBGL_UNSUPPORTED"));
        case 14:
          _t = _e.getExtension("WEBGL_debug_renderer_info");
          if (!(_t && (A = _e.getParameter(_t.UNMASKED_RENDERER_WEBGL)), !A)) {
            _context3.next = 17;
            break;
          }
          return _context3.abrupt("return", P(1, "FALLBACK"));
        case 17:
          S = A, A = r(A), b = function (e, t, r) {
            return "apple gpu" === t ? a(e, t, r) : [t];
          }(_e, A, v);
        case 18:
          _context3.next = 20;
          return Promise.all(b.map(function (t) {
            var r;
            return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var e, n, o, a, i, c, l, f, _ref12, _ref13, u, h, g, _window, A, P, _iterator, _step, _e2, _e3, _t3, _r2, _n, _o, _f, _f2, b, S;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    e = function (e) {
                      var t = v ? ["adreno", "apple", "mali-t", "mali", "nvidia", "powervr"] : ["intel", "apple", "amd", "radeon", "nvidia", "geforce"];
                      for (var _i = 0, _t2 = t; _i < _t2.length; _i++) {
                        var _r = _t2[_i];
                        if (e.includes(_r)) return _r;
                      }
                    }(t);
                    if (e) {
                      _context2.next = 3;
                      break;
                    }
                    return _context2.abrupt("return");
                  case 3:
                    n = "".concat(v ? "m" : "d", "-").concat(e).concat(m ? "-ipad" : "", ".json"), o = p[n] = null !== (r = p[n]) && void 0 !== r ? r : x(n);
                    _context2.prev = 4;
                    _context2.next = 7;
                    return o;
                  case 7:
                    a = _context2.sent;
                    _context2.next = 15;
                    break;
                  case 10:
                    _context2.prev = 10;
                    _context2.t0 = _context2["catch"](4);
                    if (!(_context2.t0 instanceof s)) {
                      _context2.next = 14;
                      break;
                    }
                    throw _context2.t0;
                  case 14:
                    return _context2.abrupt("return");
                  case 15:
                    i = function (e) {
                      var t;
                      var r = (e = e.replace(/\([^)]+\)/, "")).match(/\d+/) || e.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                      return null !== (t = null == r ? void 0 : r.join("").replace(/\W|amd/g, "")) && void 0 !== t ? t : "";
                    }(t);
                    c = a.filter(function (_ref8) {
                      var _ref9 = _slicedToArray(_ref8, 2),
                        e = _ref9[1];
                      return e === i;
                    });
                    c.length || (c = a.filter(function (_ref10) {
                      var _ref11 = _slicedToArray(_ref10, 1),
                        e = _ref11[0];
                      return e.includes(t);
                    }));
                    l = c.length;
                    if (!(0 === l)) {
                      _context2.next = 21;
                      break;
                    }
                    return _context2.abrupt("return");
                  case 21:
                    _ref12 = l > 1 ? c.map(function (e) {
                      return [e, d(t, e[0])];
                    }).sort(function (_ref14, _ref15) {
                      var _ref16 = _slicedToArray(_ref14, 2),
                        e = _ref16[1];
                      var _ref17 = _slicedToArray(_ref15, 2),
                        t = _ref17[1];
                      return e - t;
                    })[0][0] : c[0], _ref13 = _slicedToArray(_ref12, 4), u = _ref13[0], h = _ref13[3], g = Number.MAX_VALUE;
                    _window = window, A = _window.devicePixelRatio, P = w.width * A * w.height * A;
                    _iterator = _createForOfIteratorHelper(h);
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        _e2 = _step.value;
                        _e3 = _slicedToArray(_e2, 2), _t3 = _e3[0], _r2 = _e3[1], _n = _t3 * _r2, _o = Math.abs(P - _n);
                        _o < g && (g = _o, f = _e2);
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                    if (f) {
                      _context2.next = 27;
                      break;
                    }
                    return _context2.abrupt("return");
                  case 27:
                    _f = f, _f2 = _slicedToArray(_f, 4), b = _f2[2], S = _f2[3];
                    return _context2.abrupt("return", [g, b, u, S]);
                  case 29:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[4, 10]]);
            }));
          }));
        case 20:
          y = _context3.sent.filter(l).sort(function (_ref18, _ref19) {
            var _ref20 = _slicedToArray(_ref18, 2),
              _ref20$ = _ref20[0],
              e = _ref20$ === void 0 ? Number.MAX_VALUE : _ref20$,
              t = _ref20[1];
            var _ref21 = _slicedToArray(_ref19, 2),
              _ref21$ = _ref21[0],
              r = _ref21$ === void 0 ? Number.MAX_VALUE : _ref21$,
              n = _ref21[1];
            return e === r ? t - n : e - r;
          });
          if (y.length) {
            _context3.next = 24;
            break;
          }
          _e4 = t.find(function (e) {
            return A.includes(e);
          });
          return _context3.abrupt("return", _e4 ? P(0, "BLOCKLISTED", _e4) : P(1, "FALLBACK", "".concat(A, " (").concat(S, ")")));
        case 24:
          _y$ = _slicedToArray(y[0], 4), C = _y$[1], E = _y$[2], L = _y$[3];
          if (!(-1 === C)) {
            _context3.next = 27;
            break;
          }
          return _context3.abrupt("return", P(0, "BLOCKLISTED", E, C, L));
        case 27:
          M = v ? i : c;
          $ = 0;
          for (_e5 = 0; _e5 < M.length; _e5++) C >= M[_e5] && ($ = _e5);
          return _context3.abrupt("return", P($, "BENCHMARK", E, C, L));
        case 31:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
export { f as getGPUTier };